/**
 * Toast store + component. Usage:
 *   import { useToast } from "@/stores/toastStore";
 *   const toast = useToast();
 *   toast.success("Video rendered!");
 *   toast.error("Something went wrong");
 */
import { create } from "zustand";

export interface Toast {
  id: string;
  type: "success" | "error" | "info";
  message: string;
}

interface ToastState {
  toasts: Toast[];
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
  dismiss: (id: string) => void;
}

export const useToast = create<ToastState>((set) => ({
  toasts: [],
  success: (message) => addToast(set, "success", message),
  error: (message) => addToast(set, "error", message),
  info: (message) => addToast(set, "info", message),
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

function addToast(
  set: (fn: (s: ToastState) => Partial<ToastState>) => void,
  type: Toast["type"],
  message: string,
) {
  const id = Math.random().toString(36).slice(2, 9);
  set((s) => ({ toasts: [...s.toasts, { id, type, message }] }));
  setTimeout(() => {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
  }, 4000);
}
